/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {AnchorExampleInSection, AnchorExampleStates, AnchorExampleHelperClasses, AnchorExampleIcons, AnchorTargetBlank, AnchorProtocol, AnchorExampleHeadings, AnchorSbankenRegular, AnchorSbankenGoto, AnchorSbankenInline, AnchorLegacyUsage, AnchorExampleHelperContrastVariations} from 'Docs/uilib/components/anchor/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components), {VisibilityByTheme, VisibleWhenVisualTest} = _components;
  if (!VisibilityByTheme) _missingMdxReference("VisibilityByTheme", true);
  if (!VisibleWhenVisualTest) _missingMdxReference("VisibleWhenVisualTest", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(VisibilityByTheme, {
      visible: "sbanken",
      children: [_jsx(_components.h2, {
        children: "Demos (Sbanken)"
      }), _jsx(_components.h3, {
        children: "Regular link (Sbanken)"
      }), _jsx(AnchorSbankenRegular, {}), _jsx(_components.h3, {
        children: "Goto link (Sbanken)"
      }), _jsx(AnchorSbankenGoto, {}), _jsx(_components.h3, {
        children: "Link in text (Sbanken)"
      }), _jsxs(_components.p, {
        children: ["In the rare cases where the link is used in text then add the class ", _jsx(_components.code, {
          children: ".dnb-anchor--inline"
        }), " to get the correct styling."]
      }), _jsx(AnchorSbankenInline, {})]
    }), "\n", _jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Anchor states"
    }), "\n", _jsx(AnchorExampleStates, {}), "\n", _jsx(_components.h3, {
      children: "Additional Anchor helper classes"
    }), "\n", _jsx(_components.p, {
      children: "To force a specific state of style, use the following classes to do so:"
    }), "\n", _jsx(AnchorExampleHelperClasses, {}), "\n", _jsx(_components.h3, {
      children: "Anchor modifiers"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: ".dnb-anchor--no-animation"
        }), " ", _jsx("a", {
          href: "/uilib/components/anchor",
          className: "dnb-anchor dnb-anchor--no-animation",
          children: "No Animation"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: ".dnb-anchor--no-style"
        }), " ", _jsx("a", {
          href: "/uilib/components/anchor",
          className: "dnb-anchor dnb-anchor--no-style",
          children: "No Style"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: ".dnb-anchor--no-hover"
        }), " ", _jsx("a", {
          href: "/uilib/components/anchor",
          className: "dnb-anchor dnb-anchor--no-hover",
          children: "No Hover"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: ".dnb-anchor--no-underline"
        }), " ", _jsx("a", {
          href: "/uilib/components/anchor",
          className: "dnb-anchor dnb-anchor--no-underline",
          children: "No Underline"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Anchor with icons"
    }), "\n", _jsxs(_components.p, {
      children: ["Icons can be added with the ", _jsx(_components.code, {
        children: "icon"
      }), " and ", _jsx(_components.code, {
        children: "iconPosition"
      }), " props. Normally by sending in the name if an icon, but it is also possible to send in html/react code (normally for custom svg)."]
    }), "\n", _jsx(AnchorExampleIcons, {}), "\n", _jsxs(_components.h3, {
      children: ["Anchor with ", _jsx(_components.code, {
        children: "target=\"_blank\""
      })]
    }), "\n", _jsx(_components.p, {
      children: "If the link opens a new window it will automatically get an icon to indicate this."
    }), "\n", _jsx(AnchorTargetBlank, {}), "\n", _jsxs(_components.p, {
      children: ["Unless the href contains ", _jsx(_components.code, {
        children: ":mailto"
      }), ", ", _jsx(_components.code, {
        children: ":tel"
      }), " or ", _jsx(_components.code, {
        children: ":sms"
      }), "."]
    }), "\n", _jsx(AnchorProtocol, {}), "\n", _jsx(_components.h3, {
      children: "Anchor in headings"
    }), "\n", _jsx(AnchorExampleHeadings, {}), "\n", _jsx(_components.h3, {
      children: "Anchor in Section"
    }), "\n", _jsx(AnchorExampleInSection, {}), "\n", _jsxs(VisibleWhenVisualTest, {
      children: [_jsx(AnchorLegacyUsage, {}), _jsx(AnchorExampleHelperContrastVariations, {})]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
